import { Menu } from "@headlessui/react";
import { mdiAccountCircle, mdiLogout, mdiMessageReplyText, mdiRefresh, } from "@mdi/js";
import React, { forwardRef, useCallback, } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDialogVisible } from "../../../actions/session";
import { useExtensionContext } from "../../../ExtensionProvider";
import { clearOAuthCredentials, setUserAPIKey, } from "../../../extensions/nexus_integration/actions/account";
import { NEXUS_BASE_URL } from "../../../extensions/nexus_integration/constants";
import { Dropdown } from "../../../ui/components/dropdown/Dropdown";
import { DropdownDivider } from "../../../ui/components/dropdown/DropdownDivider";
import { DropdownItem } from "../../../ui/components/dropdown/DropdownItem";
import { DropdownItems } from "../../../ui/components/dropdown/DropdownItems";
import { Icon } from "../../../ui/components/icon/Icon";
import { UserCanceled } from "../../../util/CustomErrors";
import opn from "../../../util/opn";
import { isLoggedIn as isLoggedInSelector, userInfo as userInfoSelector, } from "../../../util/selectors";
const ActionButton = forwardRef(({ imageSrc, username, ...props }, ref) => (React.createElement("button", { className: "hover-overlay relative flex size-7 items-center justify-center overflow-hidden rounded-full", ref: ref, ...props }, imageSrc ? (React.createElement("img", { alt: username, className: "size-6 rounded-full", src: imageSrc })) : (React.createElement(Icon, { className: "size-6 text-neutral-moderate", path: mdiAccountCircle, size: "none" })))));
export const ProfileSection = () => {
    const dispatch = useDispatch();
    const extensions = useExtensionContext();
    const api = extensions.getApi();
    const { t } = useTranslation();
    const loggedIn = useSelector(isLoggedInSelector);
    const userInfo = useSelector(userInfoSelector);
    const handleRefreshUserInfo = useCallback(() => {
        api.events.emit("refresh-user-info");
    }, [api]);
    const handleLogout = useCallback(() => {
        dispatch(setUserAPIKey(undefined));
        dispatch(clearOAuthCredentials(null));
    }, [dispatch]);
    const handleProfileClick = useCallback(() => {
        if (loggedIn && userInfo?.userId !== undefined) {
            opn(`${NEXUS_BASE_URL}/users/${userInfo.userId}`).catch(() => { });
        }
        else {
            dispatch(setDialogVisible("login-dialog"));
            api.events.emit("request-nexus-login", (err) => {
                if (err != null && !(err instanceof UserCanceled)) {
                    api.showErrorNotification?.("Login Failed", err, {
                        id: "failed-get-nexus-key",
                        allowReport: false,
                    });
                }
            });
        }
    }, [api, dispatch, loggedIn, userInfo]);
    const handleSendFeedback = useCallback(() => {
        opn("https://forms.gle/YF9ED2Xe4ef9jKf99").catch(() => { });
    }, []);
    if (!loggedIn || !userInfo) {
        return React.createElement(ActionButton, { title: t("Log in"), onClick: handleProfileClick });
    }
    return (React.createElement(Dropdown, null,
        React.createElement(Menu.Button, { as: ActionButton, imageSrc: userInfo.profileUrl, title: userInfo.name ?? t("Profile"), username: userInfo.name }),
        React.createElement(DropdownItems, null,
            React.createElement(DropdownItem, { leftIconPath: mdiAccountCircle, onClick: handleProfileClick }, t("View profile on web")),
            React.createElement(DropdownDivider, null),
            React.createElement(DropdownItem, { leftIconPath: mdiRefresh, onClick: handleRefreshUserInfo }, t("Refresh user info")),
            React.createElement(DropdownItem, { leftIconPath: mdiMessageReplyText, onClick: handleSendFeedback }, t("Send feedback")),
            React.createElement(DropdownDivider, null),
            React.createElement(DropdownItem, { leftIconPath: mdiLogout, onClick: handleLogout }, t("Logout")))));
};
